import { combineReducers } from 'redux';
import { order } from '../pages/order/orderRedux/orderReducer';

const RootReducer = combineReducers({
  order,
});

export default RootReducer;
